import React from 'react';
interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
}
export function Badge({
  children,
  variant = 'default',
  size = 'md'
}: BadgeProps) {
  const variantStyles = {
    default: 'bg-gray-100 text-gray-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-yellow-100 text-yellow-700',
    error: 'bg-red-100 text-red-700'
  };
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  };
  return <span className={`inline-flex items-center rounded-full font-gotham font-medium ${variantStyles[variant]} ${sizeStyles[size]}`} data-id="element-4222">
      {children}
    </span>;
}